import { Injectable, computed, inject } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { AlertSettingsService } from '../../Modules/Settings/Services/alert-settings.service';
import { ResourceStateService } from '../../Modules/Shared/Services/resource-state.service';
import { MetricState } from '../../Modules/Shared/Types/metric-state.type';

import { LaravelDefaultResponse } from '../../Interfaces/api/shared/response.interface';
import {
  AlertKindResponse,
  AlertSettingsEnvelope,
  AlertSettingsResponse,
} from '../../Interfaces/api/backoffice/settings.interface';

@Injectable()
export class AlertSettingsFacade {
  private readonly _settingsService = inject(AlertSettingsService);
  private readonly _resourceState = inject(ResourceStateService);

  private readonly _settings = httpResource<LaravelDefaultResponse<AlertSettingsEnvelope>>(() =>
    this._settingsService.settingsRequest(),
  );

  readonly settings = computed<AlertSettingsResponse | null>(() =>
    this._settingsService.toSettings(this._resourceState.valueOf(this._settings)),
  );

  readonly state = computed<MetricState>(() =>
    this._resourceState.metricState(this._settings.status()),
  );

  readonly alerts = computed<AlertKindResponse[]>(() => this.settings()?.alerts ?? []);

  readonly isWritable = computed<boolean>(() => this.settings()?.writable ?? false);

  readonly unconfiguredCount = computed<number>(
    () => this.alerts().filter((alert) => !alert.configured).length,
  );

  readonly trackedCommands = computed<string[]>(() => this.settings()?.tracked_commands ?? []);

  reload(): void {
    this._settings.reload();
  }
}
